var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ma-6"},[_c('h4',{staticClass:"text-center keycolumn ma-0 pt-4 pb-4",class:{
      'primary--text': !_vm.$vuetify.theme.dark,
      'black--text': _vm.$vuetify.theme.dark,
    }},[_vm._v(" Frequently Asked Questions ")]),_c('faq')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }